<template>
  <div class="wrapper">
    <notifications></notifications>
    <div class="main-panel" id="mainPanel">
      <TopNavbar></TopNavbar>

      <Content></Content>

      <ContentFooter></ContentFooter>
    </div>
  </div>
</template>
<style lang="scss">

</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import Content from './Content.vue'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      Content
    },
    methods: {

    }
  }

</script>



// WEBPACK FOOTER //
// Layout.vue?f56cd212